export default {"src":"/_next/static/media/footerTopLoginSitter.b7a97697.svg","height":207,"width":395,"blurWidth":0,"blurHeight":0};